export default "__VITE_ASSET__DetGqvN2__"